class customSelect extends HTMLElement {

  constructor() {
    super();
    this.elem = this.querySelector('select');
    this.bubbles = false;
    this.mainClass = 'custom-select';
    this.titleClass = 'custom-select__title';
    this.listClass = 'custom-select__list';
    this.selectedClass = 'is-selected';
    this.openClass = 'is-open';
    this.selectOptions = this.elem.options;
    this.optionsLength = this.selectOptions.length;
    this.index = 0;
    
    // creating the select container
    this.selectContainer = document.createElement('div');
    this.selectContainer.className = this.mainClass;
    if (this.elem.id) {
      this.selectContainer.id = 'custom-' + this.elem.id;
    }

    // creating the always visible main button
    this.button = document.createElement('button');
    this.button.className = this.titleClass;
    this.button.textContent = this.generateListInnerHtml(this.selectOptions[0].textContent, '-');

    // creating the ul
    this.ul = document.createElement('ul');
    this.ul.className = this.listClass;
    this.generateOptions(this.selectOptions);

    // appending the button and the list to the container
    this.selectContainer.appendChild(this.button);
    this.selectContainer.appendChild(this.ul);
    this.selectContainer.addEventListener('click', this.onClick.bind(this));

    // selectContainer is ready - append it and hide the original
    this.elem.parentNode.insertBefore(this.selectContainer, this.elem);
    this.elem.classList.add('visually-hidden');

    // Closes the current select on any click outside of it.
    window.addEventListener('click', this.clickedOutside.bind(this));

  }

  /**
   * generateOptions
   * @description Render options for the whole select
   */
  generateOptions(options) {
    for (var i = 0; i < options.length; i++) {
      const li = document.createElement('li');
      li.innerHTML = this.generateListInnerHtml(options[i].textContent.trim(), '-');
      li.setAttribute('data-value', options[i].value);
      li.setAttribute('data-index', this.index++);

      if (this.selectOptions[this.elem.selectedIndex].textContent === options[i].textContent) {
        li.classList.add(this.selectedClass);
        this.button.innerHTML = this.generateListInnerHtml(options[i].textContent, '-');
      }

      this.ul.appendChild(li);
    }
  }
  
  /**
   * onClick
   * @description - Handles the clicks on current select.
   */
  onClick(e) {
    e.preventDefault();

    var t = e.target; 

    if (t.className === this.titleClass) {
      this.toggle(this.ul);
    }

    if (t.tagName === 'LI') {

      this.button.innerHTML = t.innerHTML;

      this.elem.options.selectedIndex = t.getAttribute('data-index');
      this.elem.options.selectedValue = t.getAttribute('data-value');

      // trigger 'change' event
      const evt = this.bubbles ? new CustomEvent('change', true) : new CustomEvent('change');
      this.elem.dispatchEvent(evt);

      // highlight the selected
      for (let i = 0; i < this.optionsLength; i++) {
        this.ul.querySelectorAll('li')[i].classList.remove(this.selectedClass);
      }
      t.classList.add(this.selectedClass);

      // remove selected from placeholder
      const placeholderOption = document.querySelector('option[name="placeholder"]');
      if (placeholderOption) {
        placeholderOption.removeAttribute('selected');
      }

      // set the original select to the current value and trigger select change
      this.elem.value = this.elem.options.selectedValue;
      this.elem.dispatchEvent(new Event("change", {
        "bubbles": true
      }));

      this.close(this.ul);

    }
  }
  /**
   * generateListInnerHtml
   * @description Toggles the open/close state of the select on title's clicks.
   */
  generateListInnerHtml(string, separator = '+') {
    if (string === '') {
      return false;
    }
    var html = string;
    var stringSplit = string.split(separator);
    
    if(stringSplit[0] !== undefined && stringSplit[1] !== undefined) {
      html = `<span>${stringSplit[0]}</span><span>${stringSplit[1]}</span>`;
    }

    return html;
  }

  /**
   * toggle
   * @description Toggles the open/close state of the select on title's clicks.
   */
  clickedOutside(e) {
    if (!this.selectContainer.contains(e.target)){
      this.close(this.ul);
    } 
  }

  /**
   * toggle
   * @description Toggles the open/close state of the select on title's clicks.
   */
  toggle(ul) {
    ul.classList.toggle(this.openClass);
  }

  /**
   * open
   * @description Opens the select.
   */
  open(ul) {
    ul.classList.add(this.openClass);
  }

  /**
   * close
   * @description Closes the select.
   */
  close(ul) {
    ul.classList.remove(this.openClass);
  }
}

if (!customElements.get('custom-select')) {
  customElements.define('custom-select', customSelect);
}
